
import { defineComponent, inject } from 'vue';
import { dataKey, Ornt, State } from '../types';
import genID from '../util/genID';

export default defineComponent({
	setup() {
		const state: State = inject<any>(dataKey.STATE);
		const map = {
			date: {
				name: '日期',
				type: 'datetime-local',
				valueType: 'string',
			},
			font: {
				name: '字体',
				type: 'title',
				content: {
					size: {
						name: '大小',
						type: 'number',
						valueType: 'number',
					},
					type: {
						name: '类型',
						type: 'text',
						valueType: 'string',
					},
				},
			},
			lineLimit: {
				name: '行数限制',
				type: 'number',
				valueType: 'number',
			},
			minimumScaleFactor: {
				name: '最小缩放因子',
				type: 'number',
				valueType: 'number',
			},
			shadowColor: {
				name: '阴影颜色',
				type: 'color',
				valueType: 'string',
			},
			shadowOffset: {
				name: '阴影偏移',
				type: 'title',
				content: {
					x: {
						name: 'x',
						type: 'number',
						valueType: 'number',
					},
					y: {
						name: 'y',
						type: 'number',
						valueType: 'number',
					},
				},
			},
			shadowRadius: {
				name: '阴影弧度',
				type: 'number',
				valueType: 'number',
			},
			textColor: {
				name: '文本颜色',
				type: 'color',
				valueType: 'string',
			},
			textOpacity: {
				name: '文本透明度',
				type: 'number',
				valueType: 'number',
			},
			url: {
				name: '跳转链接',
				type: 'text',
				valueType: 'string',
			},
			style: {
				name: '日期样式',
				type: 'select',
				valueType: 'string',
				options: {
					日期: 'date',
					时间: 'time',
					计时器: 'timer',
					相对: 'relative',
					偏移: 'offset',
				},
			},
			alignText: {
				name: '文本对齐',
				type: 'select',
				valueType: 'string',
				options: {
					靠左: 'flex-start',
					居中: 'center',
					靠右: 'flex-end',
				},
			},

			image: {
				name: '图片',
				type: 'text',
				valueType: 'string',
			},
			borderColor: {
				name: '边框颜色',
				type: 'color',
				valueType: 'string',
			},
			borderWidth: {
				name: '边框宽度',
				type: 'number',
				valueType: 'number',
			},
			containerRelativeShape: {
				name: '图片拐角是否依赖于容器',
				type: 'select',
				valueType: 'boolean',
				options: {
					是: true,
					否: false,
				},
			},
			imageOpacity: {
				name: '图片透明度',
				type: 'number',
				valueType: 'number',
			},
			imageSize: {
				name: '图片尺寸',
				type: 'title',
				content: {
					width: {
						name: '宽度',
						type: 'number',
						valueType: 'number',
					},
					height: {
						name: '高度',
						type: 'number',
						valueType: 'number',
					},
				},
			},
			resizable: {
				name: '是否可以缩放',
				type: 'select',
				valueType: 'boolean',
				options: {
					是: true,
					否: false,
				},
			},
			tint: {
				name: '蒙版',
				type: 'title',
				content: {
					color: {
						name: '颜色',
						type: 'color',
						valueType: 'string',
					},
					opacity: {
						name: '透明度',
						type: 'number',
						valueType: 'number',
					},
				},
			},
			contentMode: {
				name: '填充模式',
				type: 'select',
				valueType: 'string',
				options: {
					适当: 'fit',
					充满: 'fill',
				},
			},
			alignImage: {
				name: '图片对齐',
				type: 'select',
				valueType: 'string',
				options: {
					靠左: 'flex-start',
					居中: 'center',
					靠右: 'flex-end',
				},
			},

			text: {
				name: '文本',
				type: 'text',
				valueType: 'string',
			},

			length: {
				name: '空白长度',
				type: 'number',
				valueType: 'string',
			},

			backgroundColor: {
				name: '背景颜色',
				type: 'color',
				valueType: 'string',
			},
			backgroundGradient: {
				name: '背景渐进色',
				type: 'title',
				content: {
					colors: {
						name: '颜色集合',
						type: 'text',
						valueType: 'string',
					},
					locations: {
						name: '位置集合',
						type: 'text',
						valueType: 'string',
					},
					angle: {
						name: '角度',
						type: 'number',
						valueType: 'number',
					},
				},
			},
			backgroundImage: {
				name: '背景图片',
				type: 'text',
				valueType: 'string',
			},
			refreshAfterDate: {
				name: '刷新时间',
				type: 'datetime-local',
				valueType: 'string',
			},
			spacing: {
				name: '内部间距',
				type: 'number',
				valueType: 'number',
			},
			padding: {
				name: '外部边距',
				type: 'title',
				content: {
					top: {
						name: '上边距',
						type: 'number',
						valueType: 'number',
					},
					left: {
						name: '左边距',
						type: 'number',
						valueType: 'number',
					},
					bottom: {
						name: '下边距',
						type: 'number',
						valueType: 'number',
					},
					right: {
						name: '右边距',
						type: 'number',
						valueType: 'number',
					},
				},
			},

			size: {
				name: '容器尺寸',
				type: 'title',
				content: {
					width: {
						name: '宽度',
						type: 'number',
						valueType: 'number',
					},
					height: {
						name: '高度',
						type: 'number',
						valueType: 'number',
					},
				},
			},
			cornerRadius: {
				name: '拐角弧度',
				type: 'number',
				valueType: 'number',
			},
			layout: {
				name: '布局方式',
				type: 'select',
				valueType: 'string',
				options: {
					横向布局: Ornt.X,
					纵向布局: Ornt.Y,
				},
			},
			alignContent: {
				name: '内容对齐',
				type: 'select',
				valueType: 'string',
				options: {
					顶部: 'flex-start',
					底部: 'flex-end',
					居中: 'center',
				},
			},
		};
		return { state, map, genID };
	},
});
